import { render, staticRenderFns } from "./FormPurchaseLimit.vue?vue&type=template&id=24d2f3a0"
import script from "./FormPurchaseLimit.vue?vue&type=script&lang=js"
export * from "./FormPurchaseLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormPurchaseLimit.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d2f3a0')) {
      api.createRecord('24d2f3a0', component.options)
    } else {
      api.reload('24d2f3a0', component.options)
    }
    module.hot.accept("./FormPurchaseLimit.vue?vue&type=template&id=24d2f3a0", function () {
      api.rerender('24d2f3a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/FormPurchaseLimit.vue"
export default component.exports